// extracted by mini-css-extract-plugin
module.exports = {"back-link-container":"_tUvgo5hBv8TCF9iQNEm8","button":"_3o-TuoJ8rI6Xeilj0rPeuO"};